import { useQuery } from '@tanstack/react-query';

import { NotificationResource } from '@/types/resources';
import { api } from '@/utils/api';

interface NotificationData {
  freelancer_id: string;
  signed_at: string;
  signer_name: string;
}

export type Notifications = Array<NotificationResource<NotificationData>>;

const useVacationRequestedNotifications = (
  userId?: number | string,
  enabled = true,
  onlyUnread = true,
) => {
  const queryKey = [
    'vacation_requested',
    {
      notifiableType: 'App\\Notifications\\FreelancerHolidayRequested',
      notifiableId: userId,
      onlyUnread,
    },
  ];

  const { data: notifications } = useQuery<Notifications>(
    queryKey,
    () =>
      api.get<never, Notifications>('/v1/notifications', {
        params: {
          'filter[type]': 'App\\Notifications\\FreelancerHolidayRequested',
          ...(onlyUnread && { 'filter[unread]': 1 }),
          'filter[notifiable_type]': 'App\\Models\\User',
          ...(userId && { 'filter[notifiable_id]': userId }),
          sort: onlyUnread ? '-created_at' : 'unread_first',
        },
      }),
    {
      staleTime: 60 * 1000,
      enabled,
    },
  );

  return {
    notifications,
    queryKey,
  };
};

export default useVacationRequestedNotifications;
